// src/utils/getLocalizedString.ts
export function getLocalizedString(
  value: Record<string, string> | string | null | undefined,
  locale: string = 'en'
): string {
  if (!value) return '';
  if (typeof value === 'string') return value;

  // Return the requested locale or fallback
  const returnValue =
    value[locale] || value['en'] || Object.values(value)[0] || '';

  if (returnValue !== null && typeof returnValue === 'object') {
    return '';
  }
  return returnValue;
}
